import { USER_BONUS_TABLE_EN_US } from "#components/tables/reports/user-bonus-table/translations";
import { TRANSACTIONS_REPORT_EN_US } from "#components/transactions-report/translations";
import { BARS_AND_SECTORS_EN_US } from "#pages/place/bars/translations/bars-and-sectors-en-us";
import { BONUS_CATEGORIES_EN_US } from "#pages/place/bonus-categories/translations";
import { CATERING_EN_US } from "#pages/place/catering/translations/catering-en-us";
import { EXTRACT_EN_US } from "#pages/place/extract-new/translations";
import { BONUS_REPORT_FOR_PLACE_EN_US } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { BONUS_REPORT_EN_US } from "#pages/place/financial-reports/bonus-report/translations";
import { precharge_EN_US } from "#pages/place/precharge/pages/translations";
import { IMPORT_EN_US } from "#pages/place/purchase-invoice/import-invoice/translations/import-en-us";
import { PURCHASE_INVOICE_EN_US } from "#pages/place/purchase-invoice/translations/purchase-invoice-en-us";
import { WIZARD_EN_US } from "#pages/place/wizard/translations/wizard-en-us";
import { audits } from "./audits";
import { barReports } from "./bar-reports";
import { businessIntelligence } from "./business-intelligence/";
import { coala } from "./coala";
import { contracts } from "./contracts";
import { delivery } from "./delivery";
import { discountCategory } from "./discount-category";
import { emissionErrors } from "./emission-errors";
import { emited } from "./emited";
import { entrance } from "./entrance";
import { entranceBilling } from "./entrance-billing/";
import { events } from "./events/";
import { extract } from "./extract";
import { financialReport } from "./financial-report/";
import { fiscalReport } from "./fiscal-report";
import { guestList } from "./guest-list/";
import { importXml } from "./import-xml";
import { inventoryControl } from "./inventory-control";
import { invoicesBackups } from "./invoices-backups";
import { invoicesIva } from "./invoices-iva";
import { invoicesNational } from "./invoices-national";
import { kardex } from "./kardex";
import { kds } from "./kds";
import { manageDevices } from "./manage-devices";
import { multivendor } from "./multivendor";
import { notEmitedProducts } from "./not-emited-products";
import { passwordCard } from "./password-card";
import { placeData } from "./place-data";
import { pos } from "./pos";
import { prechargeReports } from "./precharge-reports";
import { productMenu } from "./product-menu";
import { products } from "./products";
import { productArea } from "./products/product-area";
import { productDetail } from "./products/product-detail";
import { promotion } from "./promotion";
import { promotions } from "./promotions";
import { rechargeManagement } from "./recharge-management";
import { recharges } from "./recharges";
import { reserve } from "./reserve";
import { reserveV2 } from "./reserve-v2";
import { search } from "./search";
import { settings } from "./settings";
import { storage } from "./storage/";
import { tagGroups } from "./tag-groups";
import { TRANSACTIONS_EN_US } from "./transactions";
import { whatsUp } from "./whats-up";

export const placeEN = {
	placeTitle: "Places",
	insights: {
		previewTitle: "RECENT INSIGHTS",
		viewAll: "View all insights",
		pageTitle: "Insights and Suggestions",
		pageSubtitle: "Recommendations automatically generated for your operation.",
		backToPlaces: "Back to Places",
		all: "All",
		noInsights: "No insights available at the moment.",
		insightCount: "insight",
		insightCountPlural: "insights",
		updatedAt: "Updated at:",
		groupedPlacesTooltip: "{{count}} places with this insight",
		closeDrawer: "Close",
		previousPlace: "Previous place",
		nextPlace: "Next place",
		unknownPlace: "Unknown place",
	},
	searchPlaceInputPlaceholder: "Search for a place",
	placeWithoutEvent: "Places without event for more than a month",
	placeWithOpenEvent: "Places with an event in progress",
	placeWithoutEventInProgress: "Places without an event in progress",
	timezone: "Timezone",
	currency: "Currency",
	subtitle: "Legend",
	alphabeticalOrder: "Alphabetical order",
	lastEventOrder: "Last event created",
	initialDefaultDateOrder: "Default date filter",
	financialFile: {
		title: "Financial file",
		description: "Track your equipment and subscription requests.",
		titleDescription: "Description",
		table: {
			columns: {
				name: "Name",
				contractId: "Contract",
				period: "Period",
			},
		},
		downloadButton: "Download",
		eventType: {
			festival: "Festival",
			fixedVenue: "Fixed House",
			event: "Event",
			sports: "Sports",
			fairs: "Fairs",
			beachClub: "Beach Club",
			retail: "Retail",
			bar: "Bar",
			others: "Other",
			hotel: "Hotel",
			restaurant: "Restaurant",
			school: "School",
			arena: "Arena (Stadium)",
			hospitality: "Hospitality",
			nightclub: "Nightclub",
			barRestaurant: "Bar & Restaurant",
			beachTennisCourt: "Beach Tennis Court",
			carnival: "Carnival",
			juneParty: "June Party",
			musicFestival: "Music Festival",
			show: "Concert",
			newYearsEve: "New Years Eve",
			eventVenue: "Event venue",
			musicShow: "Music concert",
			sportsEvent: "Sports event",
			gastronomicEvent: "Gastronomic Event",
			religiousEvent: "Religious event",
			schoolEvent: "School event",
			seasonalHouse: "Temporary House",
		},
		eventModel: {
			monthly: "Monthly",
			weekly: "Weekly",
			oneTime: "Single",
		},
		invoiceType: {
			daily: "Daily",
			weekly: "Weekly",
			monthly: "Monthly",
			atTermination: "At the End",
			perSession: "Per Session",
		},
		financialClosingTitle: "Financial Closing",
		zigDataSection: "Data - Zig",
		currency: "Currency",
		document: "Document",
		name: "Name",
		address: "Address",
		eventDataSection: "Data - Event",
		period: "Period",
		notInformed: "Not informed",
		type: "Type",
		zigExecutive: "Zig Executive",
		model: "Model",
		billing: "Billing",
		automaticRepayment: "Automatic Repayment",
		yes: "Yes",
		no: "No",
		placeId: "PlaceId",
		organizationId: "OrganizationId",
		clientDataSection: "Data - Client",
		client: "Client",
		contract: "Contract",
		contractValidity: "Contract Validity",
		eventBillingHeader: "Billing - Event",
		value: "Value",
		total: "Total",
		totalBilling: "Total Billing",
		zigBillingHeader: "Billing - Zig",
		item: "Item",
		base: "Base",
		taxRate: "Rate (%)",
		zigInvoiceSummary: "Zig Invoice Summary",
		finalResultHeader: "Final Result",
		integratedAcquiringBalance: "Balance generated by Integrated Acquiring",
		nonIntegratedAcquiringBalance: "Balance generated by Non-Integrated Acquiring",
		zigInvoice: "Zig Invoice",
		balanceToTransfer: "Balance to Transfer",
		finalBalanceToTransfer: "Final Balance to Transfer",
		technicalAnalysisHeader: "Technical Analysis",
		previousValue: "Previous Value",
		newValue: "New Value",
		issuance: "Issuance",
		date: "Date",
		version: "Version",
		meta: "Meta",
		others: "Others",
		eventEntries: "Event Entries",
		totalBalance: "Total Final",
		tpvOthers: "POS Others",
		integratedAcquiring: "Integrated Acquiring",
		nonIntegratedAcquiring: "Non-Integrated Acquiring",
		zigBilling: "ZIG Billing",
		balanceMovement: "Balance Movement",
		to: "to",
	},
	subtitles: {
		onGoingEvent: "Ongoing event",
		recentEvent: "Recent event",
		longTimeWithoutEvent: "Long time without event",
		waitingForApproval: "Waiting for approval",
		noEvent: "No event",
	},
	placelinks: {
		post: "Post",
		pre: "Pre",
		noEvents: "Without events",
		none: "No event",
		openEvent: "Open event",
	},
	placeTabs: {
		products: " Products",
		combos: " Combos",
		supplies: " Inputs",
		bars: " Bars",
		beer: " Draft Beer",
		gng: " Grab and Go",
		cmv: " Eng. from Menu",
		config: "Menu Settings",
		catering: "Catering",
	},
	events,
	products,
	productMenu,
	businessIntelligence,
	entranceBilling,
	reserve,
	reserveV2,
	storage,
	financialReport,
	guestList,
	entrance,
	tagGroups,
	pos,
	promotions,
	whatsUp,
	audits,
	settings,
	precharge: precharge_EN_US,
	barReports,
	extract,
	passwordCard,
	notEmitedProducts,
	promotion,
	search,
	transactions: TRANSACTIONS_EN_US,
	invoicesIva,
	invoicesNational,
	invoicesBackups,
	kardex,
	multivendor,
	coala,
	fiscalReport,
	discountCategory,
	emissionErrors,
	emited,
	importXml,
	productDetail,
	productArea,
	inventoryControl,
	prechargeReports,
	contracts,
	rechargeManagement,
	recharges,
	transactionsReport: TRANSACTIONS_REPORT_EN_US,
	bonusCategories: BONUS_CATEGORIES_EN_US,
	kds,
	purchaseInvoiceV2: PURCHASE_INVOICE_EN_US,
	import: IMPORT_EN_US,
	delivery,
	extractNew: EXTRACT_EN_US,
	userBonusTable: USER_BONUS_TABLE_EN_US,
	bonusReport: BONUS_REPORT_EN_US,
	bonusReportForPlace: BONUS_REPORT_FOR_PLACE_EN_US,
	placeData,
	managerOrders: {
		orderDetailModal: {
			title: "Order details",
			orderNumber: "Order no. #{{orderNumber}}",
			nameLabel: "Name",
			dateLabel: "Date and time",
			dateValue: "{{date}} at {{hour}}",
			originLabel: "Order origin",
			refuseOrder: "Decline order",
			acceptOrder: "Accept order",
			cancelOrder: "Cancel order",
			readyOrder: "Order ready",
			dispatchOrder: "Dispatch order",
			concludeOrder: "Complete order",
			itemsTitle: "Order items",
			itemsColumnName: "Item",
			itemsColumnUnitPrice: "Unit price",
			itemsColumnTotalPrice: "Total price",
			totalLabel: "Total",
			deliveryFeeLabel: "Delivery fee",
			serviceFeeLabel: "Service fee",
			additionalFeeLabel: "Minimum order fee",
			discountLabel: "Discount",
			discountStoreLabel: "Store discount",
			discountMarketplaceLabel: "iFood discount",
			discountKeetaLabel: "Keeta discount",
			discountFood99Label: "99Food discount",
			obsLabel: "Note",
			obsTitle: "Additional notes",
			deliveryDetailsTitle: "Delivery details",
			paymentMethodLabel: "Payment method",
			paymentMethodCardValue: "Card",
			changeBackLabel: "Change to return",
			deliveryTypeLabel: "Delivery type",
			deliveryByStoreValue: "Store delivery",
			deliveryByPlatformValue: "Platform delivery",
			locatorLabel: "Locator",
			needCutleryLabel: "Cutlery",
			needCutleryYes: "Customer requested cutlery",
			addressLabel: "Address",
			contactLabel: "Contact",
			cpfLabel: "CPF",
			phoneLabel: "Phone",
			unknownLabel: "Unknown document",
			unknown: "Not provided",
			printOrder: "Print order",
			toastAcceptTitle: "Order accepted",
			toastAcceptDescription:
				'Order <bold>#{{orderNumber}}</bold> was accepted and can be found in the "<bold>Accepted</bold>" tab',
			toastReadyTitle: "Order ready",
			toastReadyDescription:
				'Order <bold>#{{orderNumber}}</bold> was marked as ready and can be found in the "<bold>Ready</bold>" tab',
			toastDispatchTitle: "Order dispatched",
			toastDispatchDescription:
				'Order <bold>#{{orderNumber}}</bold> was dispatched and can be found in the "<bold>In delivery</bold>" tab',
			toastConcludeTitle: "Order completed",
			toastConcludeDescription:
				'Order <bold>#{{orderNumber}}</bold> was completed and can be found in the "<bold>Completed</bold>" tab',
			toastCancelTitle: "Order cancelled",
			toastCancelDescription:
				'Order <bold>#{{orderNumber}}</bold> was cancelled and can be found in the "<bold>Cancelled</bold>" tab',
			statusMessagePlaced: "Accept or decline the order to continue.",
			statusMessageConfirmed: "Prepare the order and mark it as ready when done.",
			statusMessageReady: "Dispatch when the delivery person picks up the order.",
			statusMessageReadyDineIn:
				"Complete the order when the customer picks it up on site.",
			statusMessageDispatched: "Complete the order when the delivery is finished.",
		},
		refuseOrderConfirmation: {
			title: "Decline order",
			message: "Are you sure you want to decline this order?",
			confirmButton: "Decline",
			secondaryMessage: "This action cannot be undone.",
		},
	},
	barsAndSectors: BARS_AND_SECTORS_EN_US,
	catering: CATERING_EN_US,
	manageDevices,
	wizard: WIZARD_EN_US,
};
